import React from "react";
import dailyPaySymbol from "../../../assets/Footerimg/dailypaysymbol.webp";

const GetStartedSection = () => {
  return (
<section className="w-full bg-[#1d0505] py-14 sm:py-16 lg:py-16">  
      
      <div className="
          max-w-[1200px]
          mx-auto
          px-6
          flex
          flex-col
          items-center
          justify-center
          text-center
        "
      >
        {/* LOGO */}
      <img
  src={dailyPaySymbol}
  alt="DailyPay Symbol"
  className="
    w-[75px]
    h-[75px]
    lg:h-[60px]
    lg:w-[75px]
    md:h-[60px]
    md:w-[75]
    sm:w-[65px]
    sm:h-[24px]
    object-contain
  "
/>

        {/* HEADING */}
       <h2
  className="
    mt-10
    text-white
    text-[56px]
    sm:text-[56px]
    md:text-[58px]
    lg:text-[58px]
    leading-[0.95]
    lg:leading-[1]
    font-normal
    max-w-[980px]
    md-max-w-[950px]
  "
  style={{
    fontFamily:
      '"Cormorant Garamond", serif',
  }}
>
  {/* MOBILE */}
  <span className="block lg:hidden md:hidden">
    Learn how you
    <br />
    can get started
    <br />
    with on-
    <br />
    demand pay
  </span>

  {/* LAPTOP / DESKTOP */}
  <span className="hidden lg:block md:block">
    Learn how you can get started
    <br />
    with on-demand pay
  </span>
</h2>

        {/* BUTTON */}
        <button
          className="
            mt-10
            bg-white
            text-[#3d0000]
            px-6
            py-2
            lg:px-5
            lg:py-2
            text-[18px]
            font-semibold
            hover:bg-[#f4f4f4]
            transition-all
            duration-300
          "
        >
          Let’s Talk
        </button>
      </div>
    </section>
  );
};

export default GetStartedSection;